import { StatusEnum } from "../../utils/status";
import { apiFGTS } from "../http/httpClient";

export interface ProposalObservation {
  observacao: string;
  dataObservacao: string;
}

export interface TransactionByIdResponse {
  _id: string;
  contract: number;
  value: number;
  commission: number;
  commissionList?: Array<{
    name: string;
    type: string;
    value: number;
    status: string;
  }>;
  status: StatusEnum;
  actualStatus: StatusEnum;
  type: string;
  seller: {
    _id: string;
    name: string;
    profileImageUrl: string;
    transactions_count: number;
  };

  customer: {
    _id: string;
    name: string;
    cpf: string;
  };

  team: {
    _id: string;
    name: string;
  };

  config: {
    canEdit: boolean;
    canRefuse: boolean;
    canApprove: boolean;
    canEditContact: boolean;
    canCopyFormLink: boolean;
    canViewProof: boolean;
    canUploadFiles: boolean;
    canSimulate: boolean;
    canUploadDocs?: boolean;
  };

  statusEsteira: string;
  numeroAtividade: number;
  descriptionActivity: string;
  url: string;
  tableCode: string;
  tableName: string;
  ultimaObservacao: string;

  observacoes?: ProposalObservation[];
  reason_to_cancel: string;

  support?: {
    link?: string;
    observation?: string;
    canUploadDocs?: boolean;
    documents?: string[];
  };

  updatedAt: string;
  createdAt: string;
}

interface TransactionByIdOptions {
  store?: boolean;
}

export async function transactionById(
  id: string,
  { store }: TransactionByIdOptions = {},
) {
  const { data } = await apiFGTS.get<TransactionByIdResponse>(
    `/transaction/${id}`,
    {
      params: store ? { store: true } : undefined,
      headers: { "x-mock-response-name": "Get transaction by ID" },
    },
  );

  return data;
}
